// extracted by mini-css-extract-plugin
export default {"container":"platform-landing_container__9vUOm","header":"platform-landing_header__68WZR","login":"platform-landing_login__jkPbF"};